import BookingStatus from '@/models/Bookings/BookingStatus';

export default class BookingStatusViewModel {
    name: string;
    value: BookingStatus;

    public constructor(name: string, value: BookingStatus) {
        this.name = name;
        this.value = value;
    }
}